import { types, actions } from './requests'
export const GETLISTING_TYPES = {
    ...types('GETLISTING'),
}
export const GETLISTING_ACTIONS = {
    ...actions('GETLISTING'),
}